module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _vm._v(" "), _c('requests-chart', {
    attrs: {
      "stats": _vm.rtxStats
    }
  }), _vm._v(" "), _c('center', [_c('check-box', {
    attrs: {
      "no-form": ""
    },
    model: {
      value: (_vm.sry),
      callback: function($$v) {
        _vm.sry = $$v
      },
      expression: "sry"
    }
  }, [_vm._v("View Summary")])], 1), _vm._v(" "), (!_vm.sry) ? _c('data-table', {
    ref: "rtxtable",
    attrs: {
      "table-ref": "rtxtable",
      "title": "Requests Report",
      "url": '/report/requests/summary' + (_vm.isTelco() ? '/' + this.org().id : (_vm.sharer ? '/' + _vm.sharer : '')),
      "fields": _vm.fields,
      "sort-field": "targetDate|desc,priority|asc",
      "detail-component": "request-report-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "rtxDetails",
      fn: function(props) {
        return [_c('el-row', [(props.rowData.partyNo === 1) ? _c('el-col', {
          attrs: {
            "span": 16
          }
        }, [_c(_vm.heading, {
          tag: "span",
          class: _vm.formatRequest(props.rowData.actionType)
        }, [_c('b', [_vm._v(_vm._s(props.rowData.actionType))]), _vm._v(" " + _vm._s(props.rowData.status) + " (" + _vm._s(props.rowData.stepNo) + "):\n        ")]), _vm._v(" "), _c(_vm.heading, {
          tag: "span"
        }, [_vm._v(" \n          "), _c('b', [_vm._v("["), _c('span', {
          staticClass: "text-warning"
        }, [_vm._v(_vm._s(props.rowData.shortRequestor)), (props.rowData.telcoSiteId) ? _c('span', [_vm._v(" " + _vm._s(props.rowData.telcoSiteId))]) : _vm._e()]), _vm._v("]\n             " + _vm._s(props.rowData.siteName) + "\n          ")]), _vm._v("\n           "), _c('small', [_vm._v("Step " + _vm._s(props.rowData.currentStep) + " / " + _vm._s(_vm.formatInteger(props.rowData.totalSteps)))])]), _vm._v(" "), _c('p', [_vm._v("\n          Total Files: "), _c('b', [_vm._v(_vm._s(_vm.formatInteger(props.rowData.totalFiles)))]), _vm._v(" "), (props.rowData.uploadedFiles > 0) ? _c('span', {
          staticClass: "text-primary"
        }, [_vm._v(" | Uploaded Files: "), _c('b', [_vm._v(_vm._s(_vm.formatInteger(props.rowData.uploadedFiles)))])]) : _vm._e(), _vm._v(" "), (props.rowData.approved > 0) ? _c('span', {
          staticClass: "text-info"
        }, [_vm._v(" | Approved Steps: "), _c('b', [_vm._v(_vm._s(_vm.formatInteger(props.rowData.approved)))])]) : _vm._e(), _vm._v(" "), (props.rowData.approved > 0) ? _c('span', {
          staticClass: "text-primary"
        }, [_vm._v(" | Completed Steps: "), _c('b', [_vm._v(_vm._s(_vm.formatInteger(props.rowData.completed)))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (props.rowData.partyNo === 1 && _vm.isActive(props.rowData)) ? _c('el-col', {
          attrs: {
            "span": 8,
            "align": "right"
          }
        }, [(props.rowData.priority) ? _c('span', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatPriority(props.rowData.priority))
          }
        }), _vm._v(" | ")]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.formatFriendlyDate(props.rowData.targetDate),
            "placement": "top"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatStatus(props.rowData.timeline))
          }
        })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 6,
            "align": "left"
          }
        }, [_c('b', [_vm._v(_vm._s(props.rowData.partyName))]), _vm._v(" "), _c('span', {
          staticClass: "text-info"
        }, [_vm._v("(Files "), _c('b', [_vm._v(_vm._s(props.rowData.partyFiles) + "/" + _vm._s(props.rowData.totalPartyFiles))]), _vm._v(")")])]), _vm._v(" "), _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 14,
            "align": "center"
          }
        }, [_c('el-progress', {
          attrs: {
            "stroke-width": 10,
            "percentage": Number(props.rowData.percent),
            "color": _vm.customColors
          }
        })], 1)], 1)]
      }
    }], null, false, 130866608)
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" Requests Report")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1a9fe3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/requests/RequestsReport.vue
// module id = 1578
// module chunks = 0